<template>
  <div id="orderdetail" class="full_layout orderdetail" v-loading.fullscreen="loading">
    <div v-if="orderInfo!=null" class="">
      <div class="cartTitle">
        <h3>订单详情</h3>
      </div>
      <div v-if="orderInfo.Status==6" class="orderClose">该订单已关闭</div>
      <div class="orderType" v-if="orderInfo.Status!=6">
        <div :class="orderInfo.Status>=1?'on':''">
          <div class="type">
            <span></span>
            待支付
          </div>
          <div class="dot">
            <span></span>
            <span></span>
          </div>
        </div>
        <div :class="orderInfo.Status>=2&&orderInfo.IsPay?'on':''">
          <div class="type">
            <span></span>
            待发货
          </div>
          <div class="dot">
            <span></span>
            <span></span>
          </div>
        </div>
        <div :class="orderInfo.Status>=3&&orderInfo.IsSend?'on':''">
          <div class="type">
            <span></span>
            待收货
          </div>
          <div class="dot">
            <span></span>
            <span></span>
          </div>
        </div>
        <div :class="orderInfo.Status==5&&orderInfo.IsReceive?'on':''">
          <div class="type">
            <span></span>
            {{orderInfo.Status==6?'关闭':'完成'}}
          </div>
        </div>
      </div>
      <div class="orderType" v-if="orderInfo.Status==6">
        <div :class="orderInfo.Status>=1?'on':''">
          <div class="type">
            <span></span>
            待支付
          </div>
          <div class="dot">
            <span></span>
            <span></span>
          </div>
        </div>
        <div :class="orderInfo.Status>=2&&orderInfo.IsPay?'on':''" v-if="orderInfo.IsPay">
          <div class="type">
            <span></span>
            待发货
          </div>
          <div class="dot">
            <span></span>
            <span></span>
          </div>
        </div>
        <div :class="orderInfo.Status>=3&&orderInfo.IsSend?'on':''" v-if="orderInfo.IsSend">
          <div class="type">
            <span></span>
            待收货
          </div>
          <div class="dot">
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="icon_orderClose" :class="orderInfo.Status==6?'on':''">
          <div class="type">
            <span></span>
            关闭
          </div>
        </div>
      </div>
      <ul class="addressInfo">
        <li>订单号：{{orderInfo.OrderCode}}</li>
        <li>创建时间：{{orderInfo.CreateDate}}</li>
        <li v-if="orderInfo.Status>=3&&orderInfo.Express!=null&&orderInfo.Express">快递信息：{{orderInfo.ExpressName}} {{orderInfo.Express}}</li>
        <li>发货地址：{{orderInfo.Provice}} {{orderInfo.AddressDetail}} {{orderInfo.UserName}} {{orderInfo.Mobile}}</li>
      </ul>
      <!--  <div class="PayTypeTitle" v-if="orderInfo.PayType==2">支付凭证</div>
      <ul class="addressInfo PayType" v-if="orderInfo.PayType==2">
        <li>户号：{{orderInfo.TransferAccount}}</li>
        <li>户名：{{orderInfo.TransferCompany}}</li>
        <li>开户行：{{orderInfo.TransferMethod}}</li>
        <li>流水号：{{orderInfo.TransferJournal}}</li>
        <li>转账记录凭证：<el-image class="PayTypeImage" :src="orderInfo.OrderPayVouchers[0]" fit="fit" :preview-src-list="orderInfo.OrderPayVouchers"></el-image>
        </li>
      </ul> -->
      <div class="cart_list_title check_list order_detail_title cart_list">
        <div class="cart_list_products">商品</div>
        <div class="cart_list_detail">详情</div>
        <div class="cart_list_price">单价</div>
        <div class="cart_list_number">数量</div>
        <div class="cart_list_total">总价</div>
      </div>
      <div class="check_list cart_list order_detail_list" v-for="(item,index) in orderInfo.OrderDetails" :key="index">
        <div class="cart_list_products">
          <router-link class="cart_img" :to="{path:'/market/item/'+(item.OldCommodityId?item.OldCommodityId:item.CommodityId)+'?type=1'}">
            <img :src="item.TitImg+'?imageView2/2/w/160'">
            <span class="icon_presale" v-if="orderInfo.OrderPresale==1">预售</span>
          </router-link>
        </div>
        <div class="cart_list_detail space_between">
          <router-link :to="{path:'/market/item/'+(item.OldCommodityId?item.OldCommodityId:item.CommodityId)+'?type=1'}">
            <p class="line_txt3">{{item.Title}}</p>
          </router-link>
        </div>
        <!-- 非积分 总价 -->
        <div class="cart_list_price" v-if="orderInfo.OrderPresale!=2">
          <del v-if="item.LowestPrice!=item.Price">￥{{item.Price.toLocaleString()}}</del>
          <span class="price_red" v-if="item.LowestPrice!=item.Price">￥{{item.LowestPrice.toLocaleString()}}</span>
          <span v-if="item.LowestPrice==item.Price">￥{{item.Price.toLocaleString()}}</span>
        </div>
        <!-- 积分 总价 -->
        <div class="cart_list_price" v-if="orderInfo.OrderPresale==2">
          <span>{{item.PointsScore}} 积分</span>
          <span v-if="item.LowestPrice>0">+ ￥{{item.LowestPrice.toLocaleString()}}</span>
        </div>
        <div class="cart_list_number">
          <span>{{item.Num}}</span>
        </div>
        <!-- 非积分 总价 -->
        <div class="cart_list_total" v-if="orderInfo.OrderPresale!=2">
          <span v-if="orderInfo.OrderPresale!=1">￥{{priceCount(item.LowestPrice,item.Num,'multi')}}</span>
          <div v-if="orderInfo.OrderPresale==1" class="itemPresale">
            <span class="">￥{{item.AdvancePrice.toLocaleString()}}</span>
            <span class="">( 尾款 ￥{{priceCount(priceCount(item.LowestPrice,item.Num,'multi'),item.AdvancePrice,'sub')}} )</span>
            <span class="icon_payOther" v-if="orderInfo.Status==1&&orderInfo.PayType==2&&orderInfo.PayCheck==1">待审核</span>
            <!-- <span class="">( 尾款 ￥{{priceCount(item.LowestPrice,item.AdvancePrice,'sub')}} )</span> -->
          </div>
        </div>
        <!-- 积分 总价 -->
        <div class="cart_list_total" v-if="orderInfo.OrderPresale==2">
          <span>{{item.TotalPoints}} 积分</span><br />
          <span v-if="item.TotalPrice>0">+ ￥{{item.TotalPrice.toLocaleString()}}</span>
        </div>
      </div>
      <div class="subTotalBox">
        <div class='stageDetail' v-if="orderInfo.OrderPresale==1">
          <div class="stageOne" :class="!orderInfo.IsPayDeposit?'on':''">
            <div class="">
              <div class="stageRadius"></div>
              <div>阶段一</div>
              <!-- <div>支付定金 <span class="price">¥ {{priceCount(orderInfo.AdvancePrice,orderInfo.OrderDetails[0].Num,'multi').toLocaleString()}}</span></div> -->
              <div>支付定金 <span class="price">¥ {{orderInfo.AdvancePrice.toLocaleString()}}</span></div>
            </div>
            <span class="span"><i></i></span>
          </div>
          <div class="stageTwo" :class="orderInfo.IsPayDeposit?'on':''">
            <div class="">
              <div class="stageRadius"></div>
              <div>阶段二</div>
              <!-- <div>支付尾款 <span class="price">¥ {{priceCount(priceCount(orderInfo.RealOrderPrice,orderInfo.AdvancePrice,'sub'),orderInfo.OrderDetails[0].Num,'multi').toLocaleString()}}</span></div> -->
              <div>支付尾款 <span class="price">¥ {{priceCount(orderInfo.RealOrderPrice,orderInfo.AdvancePrice,'sub')}}</span></div>
            </div>
            <span class="span"><i></i></span>
          </div>
        </div>
        <div class="subTotal" v-if="orderInfo.OrderPresale==1">
          <div class="space_between total" v-if="!orderInfo.IsPayDeposit">
            <span>定金支付</span>
            <!-- <span class='price'>{{priceCount(orderInfo.AdvancePrice,orderInfo.OrderDetails[0].Num,'multi').toLocaleString()}}</span> -->
            <span class='price'>{{orderInfo.AdvancePrice.toLocaleString()}}</span>
          </div>
          <div class="space_between" v-if="orderInfo.IsPayDeposit">
            <span>总价</span>
            <span class="price">{{orderInfo.OrderPrice.toLocaleString()}}</span>
          </div>
          <div class="space_between" v-if="(orderInfo.OrderPrice!=orderInfo.RealOrderPrice)&&orderInfo.IsPayDeposit">
            <span>优惠</span>
            <span class='price price_red'>- {{priceCount(orderInfo.OrderPrice,orderInfo.RealOrderPrice,'sub').toLocaleString()}}</span>
          </div>
          <div class="space_between" v-if="orderInfo.IsPayDeposit">
            <span>定金</span>
            <span class='price price_red'>- {{orderInfo.AdvancePrice.toLocaleString()}}</span>
          </div>
          <div class="space_between total" v-if="orderInfo.IsPayDeposit">
            <span>共计</span>
            <span class='price'>{{priceCount(orderInfo.RealOrderPrice,orderInfo.AdvancePrice,'sub').toLocaleString()}}</span>
          </div>
          <el-button class='subtn' :disabled="orderInfo.PayCheck==1&&orderInfo.PayType==2" v-if="!orderInfo.IsPayDeposit&&orderInfo.Status<2" type="primary" @click="payGo()">支付定金</el-button>
          <el-button class='subtn' v-if="orderInfo.IsPayDeposit&&orderInfo.Status<2" :disabled="isPay(orderInfo)" type="primary" @click="payGo()">支付尾款</el-button>
          <div class="space_between orderPresale" v-if="orderInfo.Status==1">
            <span class="textPresale">若有优惠，优惠将在付尾款时使用</span>
          </div>
        </div>
        <div class="subTotal" v-if="orderInfo.OrderPresale!=1&&orderInfo.OrderPresale!=2">
          <div class="space_between">
            <span>总价</span>
            <span class="price">{{orderInfo.OrderPrice.toLocaleString()}}</span>
          </div>
          <div class="space_between" v-if="orderInfo.OrderPrice!=orderInfo.RealOrderPrice">
            <span>优惠</span>
            <span class='price price_red'>{{priceCount(orderInfo.OrderPrice,orderInfo.RealOrderPrice,'sub').toLocaleString()}}</span>
          </div>
          <div class="space_between total">
            <span>共计</span>
            <span class='price'>{{orderInfo.RealOrderPrice.toLocaleString()}}</span>
          </div>
          <el-button class='subtn' type="primary" v-if="orderInfo.Status==1&&orderInfo.PayCheck<0" @click="payGo()" :disabled="orderInfo.IsPay">支付</el-button>
        </div>
        <!-- 积分 -->
        <div class="subTotal" v-if="orderInfo.OrderPresale==2">
          <div class="space_between">
            <span>积分</span>
            <span class="">{{orderInfo.RealPoints}} 积分 </span>
          </div>
          <div class="space_between" v-if="orderInfo.RealOrderPrice>0">
            <span>价格</span>
            <span class='price'>{{orderInfo.RealOrderPrice.toLocaleString()}}</span>
          </div>
          
          <div class="space_between" >
            <span>运费</span>
            <span class="">到付</span>
          </div>
          <div class="space_between total">
            <span>共计</span>
            <span class=''>{{orderInfo.RealPoints}} 积分 <i v-if="orderInfo.RealOrderPrice>0">+ ￥{{orderInfo.RealOrderPrice.toLocaleString()}}</i></span>
          </div>
          <el-button class='subtn' type="primary" v-if="orderInfo.Status==1" @click="payGo()" :disabled="orderInfo.IsPay">支付</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo, numAdd, numSub, numMulti } from "@/api/public";
export default {
  name: 'orderdetail',
  components: {},
  data() {
    return {
      orderInfo: null,
      userInfo: getInfo(),
      loading: false,
    }
  },
  mounted() {},
  created() {
    this.getOrderDetail(this.$route.params.id)
  },
  beforeRouteUpdate(to, from, next) {
    this.getOrderDetail(to.params.id)
  },
  methods: {
    isPay(val) {
      let data = val
      let isTrue = true
      if (!data.IsPayment) {
        //未开启尾款
        isTrue = true
      } else {
        //已开启尾款
        isTrue = false
        if (data.PaymentPayType == 1) {
          //线上支付
          isTrue = false
        } else if (data.PaymentPayType == 2) {
          //线下支付
          isTrue = false
          if (data.PayCheck == 1 || data.PayType == 3) {
            isTrue = true
          }
        }
      }
      return isTrue
    },
    //计算价格
    priceCount(num1, num2, type) {
      let num = 0;
      if (type == 'add') {
        num = numAdd(num1, num2)
      }
      if (type == 'sub') {
        num = numSub(num1, num2)
      }
      if (type == 'multi') {
        num = numMulti(num1, num2)
      }
      return num
    },
    payGo() {
      this.$router.push({ path: '/checkout/' + this.$route.params.id })
    },
    getOrderDetail(val) {
      let that = this;
      that.loading = true;
      let data = { Id: val }
      that.$get(that.$interface.GetOrderById, data).then(res => {
        if (res.Result != 0) {
          that.orderInfo = res.Data;
        } else {
          that.$message.error(res.Msg);
        }
        that.loading = false
      })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/pay.css";

.cart_list_price>del {
  color: var(--text-secondary);
}

.cart_list .cart_list_price span.price_red {
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/pages/order/detail.vue